/**
 * CRM 金额 / 数量展示：千分位分组（默认 zh-CN）
 */

const DEFAULT_EMPTY = "—";

function stripNumberInput(value) {
  if (value === null || value === undefined) return null;
  const s = String(value).replace(/,/g, "").trim();
  if (s === "" || s === "—" || s === "-") return null;
  return s;
}

/**
 * 金额：千分位，默认最多 2 位小数；可为币种前缀字符串（兼容 formatMoney(value, currency)）
 * @param {*} value
 * @param {string|{ maxFractionDigits?: number, emptyDisplay?: string, currency?: string }} optionsOrCurrency
 */
export function formatAmount(value, optionsOrCurrency) {
  let minFractionDigits = 0;
  let maxFractionDigits = 2;
  let emptyDisplay = DEFAULT_EMPTY;
  let currency = "";

  if (typeof optionsOrCurrency === "string") {
    currency = optionsOrCurrency;
  } else if (optionsOrCurrency && typeof optionsOrCurrency === "object") {
    if (optionsOrCurrency.minFractionDigits != null) {
      minFractionDigits = optionsOrCurrency.minFractionDigits;
    }
    if (optionsOrCurrency.maxFractionDigits != null) {
      maxFractionDigits = optionsOrCurrency.maxFractionDigits;
    }
    if (optionsOrCurrency.emptyDisplay != null) {
      emptyDisplay = optionsOrCurrency.emptyDisplay;
    }
    if (optionsOrCurrency.currency != null) {
      currency = optionsOrCurrency.currency;
    }
  }

  const raw = stripNumberInput(value);
  if (raw === null) {
    return emptyDisplay;
  }
  const n = Number(raw);
  if (!Number.isFinite(n)) {
    return String(value);
  }
  const out = n.toLocaleString("zh-CN", {
    minimumFractionDigits: minFractionDigits,
    maximumFractionDigits: maxFractionDigits
  });
  return currency ? `${currency} ${out}` : out;
}

/**
 * 数量、件数等：千分位，保留必要小数位（最多 10 位）
 * @param {*} value
 * @param {string} [emptyDisplay]
 */
export function formatQuantity(value, emptyDisplay = DEFAULT_EMPTY) {
  const raw = stripNumberInput(value);
  if (raw === null) {
    return emptyDisplay;
  }
  const n = Number(raw);
  if (!Number.isFinite(n)) {
    return String(value);
  }
  return n.toLocaleString("zh-CN", { maximumFractionDigits: 10 });
}
